import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import {EDCategoryListParams, EDCategory} from "../../models/serverModels/education/EDCategory";

import * as Params from "../../models/clientModels/interfaces/apiParams";

const education = axios.create({
  baseURL: "/API",
});

export const getList = async (params: EDCategoryListParams): Promise<ResponseList<EDCategory>> =>
  education({
    url: "/EducationCategoryList",
    method: "get",
    params,
  }).then((res) => res.data);
export const getListAll = async (params: EDCategoryListParams): Promise<ResponseList<EDCategory>> =>
  education({
    url: "/EducationCategoryListAll",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EDCategory>> =>
  education({
    url: `/EducationCategory/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<EDCategory>
): Promise<ResponseItem<EDCategory>> =>
  education({
    url: "/EducationCategory",
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  education({
    url: `/EducationCategory/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EDCategory>
): Promise<ResponseItem<EDCategory>> =>
  education({
    url: `/EducationCategory/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
